/* fullr-Warenkorb (v2.10) – AJAX über Cart-API + Section Rendering, ohne Abhängigkeiten. Erzeugt von gen/cart.py. */
(function () {
  var d = document;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function drawer() { return $('[data-fr-cart-drawer]'); }
  function page() { return $('[data-fr-cart-page]'); }
  function cfg() { try { return JSON.parse(($('[data-fr-cart-config]') || {}).textContent || '{}'); } catch (e) { return {}; } }
  function ids() {
    var a = ['fr-cart-drawer', 'cart-icon-bubble'], p = page();
    if (p && p.getAttribute('data-section-id')) a.push(p.getAttribute('data-section-id'));
    return a;
  }
  var busy = false, lastFocus = null, pendingNotice = '';
  function cap(x) { x = x || ''; return x.charAt(0).toUpperCase() + x.slice(1); }

  function setBusy(on) {
    busy = on;
    $$('[data-fr-cart-body]').forEach(function (b) { b.classList.toggle('is-busy', on); b.setAttribute('aria-busy', String(on)); });
  }
  function post(url, body) {
    body = body || {};
    body.sections = ids().join(',');
    body.sections_url = location.pathname;
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { throw j; } return j; }); });
  }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function refresh() {
    return fetch(location.pathname + '?sections=' + encodeURIComponent(ids().join(',')), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(apply);
  }
  function apply(sections) {
    if (!sections) return;
    var P = new DOMParser();
    Object.keys(sections).forEach(function (id) {
      var html = sections[id]; if (!html) return;
      var doc = P.parseFromString(html, 'text/html');
      if (id === 'fr-cart-drawer') {
        var nb = $('[data-fr-cart-body]', doc), ob = $('[data-fr-cart-drawer] [data-fr-cart-body]');
        if (nb && ob) ob.innerHTML = nb.innerHTML, ob.className = nb.className;
      } else if (id === 'cart-icon-bubble') {
        var b = d.getElementById('cart-icon-bubble'), src = $('.shopify-section', doc) || doc.body;
        if (b && src) b.innerHTML = src.innerHTML;
      } else {
        var np = $('[data-fr-cart-page]', doc), op = page();
        if (np && op) op.innerHTML = np.innerHTML;
      }
    });
    after();
  }
  /* v2.15: Zubuchungs-Artikel (Serum/Shampoo zum halben Preis) nur zusammen mit der Kapsel-Kur ab 2 + 1 */
  var ZUBV = {'67797911535710': 1, '67797911961694': 1}, KUR2 = {'67676280684638': 1, '67676280750174': 1}, zubBusy = false;
  function zubGuard() {
    if (zubBusy || !window.fetch || d.cookie.indexOf('cart=') < 0) return; zubBusy = true;
    getCart().then(function (c) {
      var z = c.items.filter(function (i) { return ZUBV[String(i.variant_id)]; });
      if (!z.length || c.items.some(function (i) { return KUR2[String(i.variant_id)]; })) return;
      var u = {}; z.forEach(function (i) { u[i.key] = 0; });
      return post('/cart/update.js', { updates: u }).then(function (j) { apply(j.sections); notice('Serum und Shampoo zum halben Preis gibt es nur zur Kapsel-Kur ab 2 + 1 – wir haben sie herausgenommen.'); });
    }).catch(function () {}).then(function () { zubBusy = false; });
  }
  function after() {
    /* Lieferdatum: heute + min/max Werktage (wie in der Kaufbox) */
    $$('[data-fr-ship-dates]').forEach(function (el) {
      function add(n) { var x = new Date(); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
      try {
        var o = { weekday: 'short', day: 'numeric', month: 'short' };
        el.textContent = 'Lieferung voraussichtlich ' + add(+el.getAttribute('data-min') || 8).toLocaleDateString('de-DE', o) + ' – ' + add(+el.getAttribute('data-max') || 10).toLocaleDateString('de-DE', o);
      } catch (e) {}
    });
    if (pendingNotice) { notice(pendingNotice); pendingNotice = ''; }
    zubGuard();
  }
  function notice(msg, err) {
    $$('[data-fr-cart-notice]').forEach(function (n) { n.textContent = msg; n.hidden = !msg; n.classList.toggle('is-err', !!err); });
  }
  function fail(e) {
    var m = (e && e.description) || '';
    if (m && !/[.!?]$/.test(m)) m += '.';
    notice('Das hat nicht geklappt. ' + (m ? m + ' ' : '') + 'Bitte versuch es noch einmal.', true);
  }

  /* Öffnen / Schließen */
  function open() {
    var dr = drawer(); if (!dr) return;
    if (dr.classList.contains('is-open')) return;
    lastFocus = d.activeElement;
    dr.classList.add('is-open'); dr.setAttribute('aria-hidden', 'false');
    d.documentElement.classList.add('frc-lock');
    setTimeout(function () { var x = $('.frc-panel', dr); if (x) x.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    var dr = drawer(); if (!dr || !dr.classList.contains('is-open')) return;
    dr.classList.remove('is-open'); dr.setAttribute('aria-hidden', 'true');
    d.documentElement.classList.remove('frc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onCart() { return !!page() || cfg().isCart; }
  function show() { if (!onCart()) open(); }

  /* Aktionen */
  function run(p, opts) {
    if (busy) return Promise.resolve();
    setBusy(true);
    return p().then(function (j) { if (j && j.sections) apply(j.sections); if (opts && opts.open) show(); })
      .catch(fail).then(function () { setBusy(false); });
  }
  function lineOf(el) { var li = el.closest('[data-key]'); return li ? { key: li.getAttribute('data-key'), qty: +li.getAttribute('data-qty') || 1 } : null; }
  function item(id, qty, plan, propName, prop) {
    var it = { id: +id, quantity: qty || 1 };
    if (plan) it.selling_plan = +plan;
    if (propName && prop) { it.properties = {}; it.properties[propName] = prop; }
    return it;
  }

  d.addEventListener('click', function (e) {
    var t = e.target;
    var bubble = t.closest('#cart-icon-bubble');
    if (bubble && drawer() && !onCart()) { e.preventDefault(); open(); return; }
    if (t.closest('[data-fr-cart-close]')) { e.preventDefault(); close(); return; }
    var q = t.closest('[data-fr-qty]');
    if (q) { var l = lineOf(q); if (!l) return; var n = Math.max(0, l.qty + (+q.getAttribute('data-fr-qty'))); run(function () { return post('/cart/change.js', { id: l.key, quantity: n }); }); return; }
    var rm = t.closest('[data-fr-remove]');
    if (rm) { var l2 = lineOf(rm); if (!l2) return; run(function () { return post('/cart/change.js', { id: l2.key, quantity: 0 }); }); return; }
    var pl = t.closest('[data-fr-plan]');
    if (pl) {
      if (pl.classList.contains('is-on')) return;
      var l3 = lineOf(pl); if (!l3) return; var sp = pl.getAttribute('data-fr-plan');
      run(function () { return post('/cart/change.js', { id: l3.key, quantity: l3.qty, selling_plan: sp ? +sp : null }); });
      return;
    }
    var up = t.closest('[data-fr-upgrade]');
    if (up) {
      var l4 = lineOf(up); if (!l4) return;
      var it = item(up.getAttribute('data-fr-upgrade'), l4.qty, up.getAttribute('data-plan'), up.getAttribute('data-prop-name'), up.getAttribute('data-prop'));
      var nm = up.getAttribute('data-new') || '', n3 = up.getAttribute('data-old') || '';
      run(function () { return post('/cart/add.js', { items: [it] }).then(function () { return post('/cart/change.js', { id: l4.key, quantity: 0 }); }); })
        .then(function () { if (nm) notice(cap(nm) + ' liegt jetzt im Warenkorb' + (n3 ? ' – statt ' + n3 : '') + '.'); });
      return;
    }
    var ad = t.closest('[data-fr-add]');
    if (ad) {
      var it2 = item(ad.getAttribute('data-fr-add'), 1, ad.getAttribute('data-plan'), ad.getAttribute('data-prop-name'), ad.getAttribute('data-prop'));
      run(function () { return post('/cart/add.js', { items: [it2] }); }, { open: !ad.getAttribute('data-no-open') });
    }
  });
  d.addEventListener('keydown', function (e) {
    var dr = drawer(); if (!dr || !dr.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = $$('a[href],button:not([disabled]),input,select,[tabindex]:not([tabindex="-1"])', $('.frc-panel', dr)).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* „In den Warenkorb“ auf der PDP und überall sonst: per AJAX statt Seitenwechsel */
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]') || !drawer() || !window.fetch) return;
    e.preventDefault(); e.stopPropagation();
    if (busy) return;
    var fd = new FormData(f), id = +fd.get('id');
    if (!id) { f.submit(); return; }
    var props = {}, hasProps = false;
    fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m && v !== '') { props[m[1]] = v; hasProps = true; } });
    var it = { id: id, quantity: +(fd.get('quantity') || 1) || 1 };
    var sp = fd.get('selling_plan'); if (sp) it.selling_plan = +sp;
    if (hasProps) it.properties = props;
    /* v2.11: Zubuchung aus der Kaufbox (z. B. Serum zur Kapsel-Kur) im selben Aufruf */
    var extra = [];
    $$('[data-fr-addon]:checked:not(:disabled)', f).forEach(function (adn) { extra.push({ id: +adn.value, quantity: 1 }); });
    var C = cfg(), kur = C.kur || {}, grp = C.grp || {}, vn = C.vn || {}, days = kur[String(id)] || 0;
    var g = grp[String(id)] || 'k', nm = vn[String(id)] || (days ? 'die ' + (C.names || {})[String(days)] : '');
    var btns = $$('[type="submit"]', f).concat(f.id ? $$('[form="' + f.id + '"]') : []);
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
    var done = function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; }); };
    setBusy(true);
    var chain;
    if (days) {
      /* Kurs D13 K73–K75: keine doppelte Kur im Warenkorb */
      chain = getCart().then(function (cart) {
        var kl = cart.items.filter(function (x) { return kur[String(x.variant_id)] && (grp[String(x.variant_id)] || 'k') === g; });
        var same = kl.filter(function (x) { var p = x.selling_plan_allocation && x.selling_plan_allocation.selling_plan ? String(x.selling_plan_allocation.selling_plan.id) : ''; return x.variant_id === id && p === String(it.selling_plan || ''); });
        if (same.length && kl.length === 1 && !extra.length) { pendingNotice = cap(nm) + ' liegt schon im Warenkorb. Für eine zweite Kur tippe auf +.'; return refresh(); }
        var upd = {}; kl.forEach(function (x) { upd[x.key] = 0; });
        var pre = kl.length ? post('/cart/update.js', { updates: upd }) : Promise.resolve();
        return pre.then(function () { return post('/cart/add.js', { items: [it].concat(extra) }); }).then(function (j) {
          if (kl.length) {
            var sameV = kl.length === 1 && kl[0].variant_id === id;
            var k0 = String(kl[0].variant_id), alt = vn[k0] || ((C.names || {})[String(kur[k0])] ? 'der ' + (C.names || {})[String(kur[k0])] : '');
            pendingNotice = sameV ? (cap(nm) + (it.selling_plan ? ' kommt jetzt im Abo.' : ' kommt jetzt als Einmalkauf.')) : (cap(nm) + ' liegt jetzt im Warenkorb' + (alt ? ' – statt ' + alt : '') + '.');
          }
          apply(j.sections);
        });
      });
    } else {
      chain = post('/cart/add.js', { items: [it].concat(extra) }).then(function (j) { apply(j.sections); });
    }
    chain.then(function () { show(); }).catch(function (err) { open(); fail(err); }).then(function () { setBusy(false); done(); });
  }, true);

  /* Zurück aus dem Checkout (Seiten-Cache): Warenkorb neu laden */
  window.addEventListener('pageshow', function (e) { if (e.persisted && drawer()) refresh().catch(function () {}); });
  d.addEventListener('shopify:section:load', function () { after(); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', after); else after();
})();
